<div class="ui padded container">
  <h1 class="ui header" i18n="@@categories">Kategorien</h1>
  <app-topic-cards [topics]="topics" (selectedTopic)="selectTopic($event)"></app-topic-cards>
  <div class="ui divider"></div>
  <h1 class="ui header" i18n="@@scientific-fields">Fachrichtungen</h1>
  <app-topic-cards [topics]="subjectAreas" (selectedTopic)="selectTopic($event, true)"></app-topic-cards>
</div>
